import { render, staticRenderFns } from "./PrescriptionInfo.vue?vue&type=template&id=99cc68ca&scoped=true"
import script from "./PrescriptionInfo.vue?vue&type=script&lang=js"
export * from "./PrescriptionInfo.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionInfo.vue?vue&type=style&index=0&id=99cc68ca&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cc68ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99cc68ca')) {
      api.createRecord('99cc68ca', component.options)
    } else {
      api.reload('99cc68ca', component.options)
    }
    module.hot.accept("./PrescriptionInfo.vue?vue&type=template&id=99cc68ca&scoped=true", function () {
      api.rerender('99cc68ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/settlement/takeMedicine/PrescriptionInfo.vue"
export default component.exports